import React from "react";
import {
  Users,
  History,
  ShoppingCart,
  Wallet,
  LogOut,
  DollarSign,
  Settings,
  Play,
  X,
} from "lucide-react";

export default function Sidebar({
  activePage,
  setActivePage,
  isOpen,
  onPlayNow,
  setIsOpen,
}) {
  const menuItems = [
    { name: "Users", key: "users", icon: <Users size={20} /> },
    { name: "Game History", key: "history", icon: <History size={20} /> },
    { name: "Deposit", key: "orders", icon: <ShoppingCart size={20} /> },
    { name: "Withdrawals", key: "withdrawals", icon: <Wallet size={20} /> },
    {
      name: "Daily Income",
      key: "daily",
      icon: <DollarSign size={20} />,
    },
    {
      name: "Manage Bot & Cards",
      key: "cards",
      icon: <Settings size={20} />,
    },
    {
      name: "Play Now",
      key: "playnow",
      icon: <Play size={20} />,
      isButton: true, // mark this item
    },
  ];
  const handleLogout = (e) => {
    e.preventDefault(); // prevent default link navigation
    localStorage.removeItem("userInfo"); // remove user info if stored
    window.location.href = "/login"; // redirect to login page
  };

  return (
    <>
      {/* Mobile overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/40 md:hidden z-40"
          onClick={() => setIsOpen(false)}
        />
      )}

      {/* Sidebar */}
      <div
        className={`
          w-64 bg-black/40 backdrop-blur-xl border-r border-blue-700 p-6
          h-full flex flex-col justify-between

          fixed md:static top-0 left-0 z-50
          transform transition-transform duration-300

          ${isOpen ? "translate-x-0" : "-translate-x-full md:translate-x-0"}
        `}
      >
        {/* Mobile close button */}
        <button
          onClick={() => setIsOpen(false)}
          className="md:hidden absolute top-4 right-4 text-white"
        >
          <X size={24} />
        </button>

        {/* Top section */}
        <div>
          <h1 className="text-2xl font-bold mb-6 text-center">Admin Panel</h1>

          <div className="space-y-4">
            {menuItems.map((item) => (
              <button
                key={item.key}
                onClick={() => {
                  if (item.isButton) {
                    // run the custom button function
                    onPlayNow();
                  } else {
                    // default page switching
                    setActivePage(item.key);
                  }
                  setIsOpen(false);
                }}
                className={`flex items-center gap-3 w-full p-3 rounded-lg text-left ${
                  activePage === item.key
                    ? "bg-blue-700 text-white"
                    : "bg-blue-900/40 text-gray-300 hover:bg-blue-800"
                }`}
              >
                {item.icon}
                {item.name}
              </button>
            ))}
          </div>
        </div>

        {/* Bottom logout area */}

        <div className="mt-32">
          <button
            onClick={handleLogout}
            className="flex items-center gap-3 bg-red-600/40 hover:bg-red-600 px-3 py-2 rounded-lg"
          >
            {" "}
            <LogOut size={20} /> Logout{" "}
          </button>
        </div>
      </div>
    </>
  );
}
